/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserPoint } from '../../models/user-point';

export interface AddLoyaltyUserPoint$Params {
  'Active-Tenant-Identifier': string;
  userId: string;
      body: UserPoint
}

export function addLoyaltyUserPoint(http: HttpClient, rootUrl: string, params: AddLoyaltyUserPoint$Params, context?: HttpContext): Observable<StrictHttpResponse<UserPoint>> {
  const rb = new RequestBuilder(rootUrl, addLoyaltyUserPoint.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('userId', params.userId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserPoint>;
    })
  );
}

addLoyaltyUserPoint.PATH = '/loyalty/users/{userId}/points';
